import { Outlet } from 'react-router-dom'
import { NavRail } from '../components/NavRail'
import { TopBar } from '../components/TopBar'

export function AppShell() {
  return (
    <div className="min-h-screen flex">
      <NavRail />
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar />
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
